import {isObject} from "../helpers/object_helpers";

export default {

    methods: {
        parseErrorMessage(error) {
            const fallbackMessage = this.$nuxt.isOffline ? this.$trans('error.offline.message', 'Es scheint als wärst du offline. Bitte überprüfe Deine Netzwerkverbindung, um SPOFERAN vollständig nutzen zu können.') :
                this.$trans('error.unknown', 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später noch einmal.');

            if (!error) {
                return fallbackMessage;
            }

            // Handle plain error messages
            if (!isObject(error)) {
                return error;
            }

            // Handle request errors
            // Custom error message from our API
            if (error.message) {
                return error.message;
            }

            // Parse by status code
            const code = parseInt(error.statusCode);
            switch (code) {
                case 403:
                    return this.$trans('error.403.message' , 'Leider hast hast du keine Berechtigung die Daten anzeigen zu lassen.');
                case 404:
                    return this.$trans('error.404.message', 'Es konnten momentan keine Daten gefunden werden. Bitte versuche es später noch einmal.');
                case 422:
                    return this.$trans('error.422.message', 'Bitte überprüfe Deine Angaben und versuche es noch einmal.');
                case 503:
                    return this.$trans('error.503.message', 'Es finden aktuell Wartungsarbeiten statt. Bitte versuche es später noch einmal.');
            }
        }

    }
}

